const $ = jQuery.noConflict();

class TourPopularTabs {
    constructor() {
        this.tabsWrapper = $('.block-tabbed-tour-cards');
        this.tabsLink = $('.block-tabbed-tour-cards__trigger');
    }

    init() {
        this.tabsLink.on('click', this.toggleTab);
        this.tabsLink.first().trigger('click');
    }

    toggleTab(e) {
        const el = $(this);
        const targetId = this.dataset.target;
        const wrapper = el.closest('.block-tabbed-tour-cards');

        const target = wrapper.find(targetId);

        wrapper.find('.block-tabbed-tour-cards__tabs-item').removeClass('active');
        wrapper.find('.block-tabbed-tour-cards__trigger').removeClass('active');

        el.addClass('active');
        target.addClass('active');
    }
}

export default new TourPopularTabs();
